export enum AvailabilityStatus {
  DATE = 'date',
  AVAILABLENOW = 'available_now',
  NOTAVAILABLE = 'not_available'
}

export enum AvailabilityStatusText {
  DATE = 'Select Date',
  AVAILABLENOW = 'Available Now',
  NOTAVAILABLE = 'Not Available'
}

export enum VisibilityStatus {
  DATE = 'date',
  VISIBLENOW = 'visible_now',
  NOTVISIBLE = 'not_visible'
}

export enum VisibilityStatusText {
  DATE = 'Select Date',
  VISIBLENOW = 'Visible Now',
  NOTVISIBLE = 'Not Visible'
}